import { useAnimationFrame } from "./sensors/animationFrame";
export function useAnimationFrameThrottle(animationFramePriority = 0) {
    let lastCallback = null;
    const throttle = (callback) => {
        lastCallback = callback;
    };
    useAnimationFrame(() => {
        if (lastCallback) {
            lastCallback();
            lastCallback = null;
        }
    }, animationFramePriority);
    return {
        throttle,
    };
}
